.avatar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: var(--tempest-surface-2);
    color: var(--tempest-text);
    overflow: hidden;
    font-family: var(--tempest-font-sans);
    font-weight: var(--tempest-weight-semibold);
    text-transform: uppercase;
    flex-shrink: 0;
    user-select: none;
}

.image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.xs {
    width: 24px;
    height: 24px;
    font-size: var(--tempest-text-2xs);
}

.sm {
    width: 32px;
    height: 32px;
    font-size: var(--tempest-text-xs);
}

.md {
    width: 40px;
    height: 40px;
    font-size: var(--tempest-text-base);
}

.lg {
    width: 56px;
    height: 56px;
    font-size: var(--tempest-text-xl);
}

.xl {
    width: 80px;
    height: 80px;
    font-size: var(--tempest-text-3xl);
}

.status {
    position: relative;
}

.dot {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 28%;
    height: 28%;
    border-radius: 50%;
    border: 2px solid var(--tempest-bg);
}

.dot.online {
    background-color: var(--tempest-success-solid);
}

.dot.offline {
    background-color: var(--tempest-text-subtle);
}

.dot.busy {
    background-color: var(--tempest-danger-solid);
}
